<script>
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'AnimatedLine',
  components: {
  },
  props: {
  },
  setup (props, { expose }) {
    const animateLineEnter = (timeline, startTime) => {
      timeline.fromTo('.animated-line', { autoAlpha: 0 }, { autoAlpha: 1, duration: 1 }, startTime)
      timeline.fromTo('.loop-line', { autoAlpha: 0, strokeDashoffset: 371 }, { autoAlpha: 1, strokeDashoffset: 0, duration: 2 }, startTime)
    }
    const animateLineExit = (timeline, startTime) => {
      timeline.fromTo('.loop-line', { strokeDashoffset: 0, autoAlpha: 1 }, { strokeDashoffset: -371, autoAlpha: 0, duration: 0.5 }, startTime)
    }
    expose({ animateLineEnter, animateLineExit })
  }
})
</script>

<template>
  <div class="animated-line fixed">
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 136 181">
      <path d="M1 1c14.9824 1.52017 46.6234 14.5936 53.3285 54.7261 8.3814 50.1659 51.1745-7.8305 76.8115-5.4362 25.637 2.3942-85.1298 94.5231-76.8115 108.2581 5.6803 9.379 40.0991-6.253 41.7425 21.452" stroke="currentColor" class="loop-line" stroke-linecap="round" stroke-width="0.2" />
    </svg>
  </div>
</template>

<style lang="scss" scoped>
.animated-line {
  z-index: $z-video;
  width: 100%;
  height: 100%;
  color: $c-white;
  transform: translate(0%, 10%);
}

svg {
  top: 0;
  left: 0;
  width: 100%;
  height: 95%;
  transform: translate(0%, 6%);
}

path {
  opacity: 0;
  stroke-dasharray: 371;
  stroke-dashoffset: 371;
}
</style>
